/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}

export function getUrl() {
  // let base_info={
  //   url:"ws://127.0.0.1:9502",
  //   region_id:138,
  // };
  // let base_info={
  //   url:"wss://ws.hzsp668.com",
  //   region_id:52,
  //   positionX:116.397755,
  //   positionY:39.903179,
  //   zoom:10.5,
  //   map_key:"27bb08e974da85077764df128ad6e807"
  // };
  // let base_info={
  //   url:"wss://ws.hzsp668.com",
  //   region_id:253,
  // };
  // let base_info={
  //   url:"ws://qdm.ws.youzhan.pro",
  //   region_id:300,
  // };
  // let base_info={
  //   url:"wss://ws.kaida668.com",
  //   region_id:343,
  // };
  // let base_info={
  //   url:"wss://ws.jiaqifucai.cn",
  //   region_id:140,
  // };
  // let base_info={
  //   url:"wss://ws.chenxinjc.com",
  //   region_id:163,
  // };
  // let base_info={
  //   url:"wss://ws.qlsp168.cn",
  //   region_id:197,
  // };
  // let base_info={
  //   url:"wss://ws.fucaibashi.com",
  //   region_id:283,
  // };
  // let base_info={
  //   url:"wss://ws.rephone.com.cn",
  //   region_id:391,
  // };
  let base_info={
    url:"wss://ws.qidianmeiyuncang.com",
    region_id:300,
    map_key:"b07c7e07a146a6650437f828b0d7a575",
    positionX:112.558037,
    positionY:37.747572,
    zoom:11,
  };
  // let base_info={
  //   url:"wss://ws.whglb.cn",
  //   region_id:180,
  // };
  // let base_info={
  //   url:"ws://xcy.ws.youzhan.pro",
  //   region_id:138,
  // };
  // let base_info={
  //   url:"wss://ws.xiangyangjiancai.com",
  //   region_id:211,
  // };
  // let base_info={
  //   url:"ws://hnjn.ws.youzhan.info",
  //   region_id:151,
  //   map_key:'bed99fa71179bd3b165a7b966af5b139'
  // };
  // let base_info={
  //   url:"wss://ws.shaoxingtucan.com",
  //   region_id:389,
  //   map_key:'28c978f74b756df9a5acf9346c487c76'
  // };
  // let base_info={
  //   url:"wss://ws.xjgjiancai.com",
  //   region_id:390,
  //   map_key:'b44bb8d8a8c3b0bb125d5785d234c4fd'
  // };
  // let base_info={
  //   url:"wss://ws.fjmxsd.com",
  //   region_id:58,
  //   map_key:'1226ab7e997bbe612dfa1c25cc5ec85f'
  // };
  // let base_info={
  //   url:"wss://ws.hcyfc.com",
  //   region_id:322,
  //   map_key:'e30c4641a259783ea120b92ef44e8f0b'
  // };

  //   let base_info={
  //   url:"wss://ws.hzsp668.com",
  //   region_id:244,
  //   zoom:10.5,
  //   map_key:"948b0688ceafd0fc625dd6c65fb0f4b1"
  // };
  //  let base_info={
  //   url:"wss://ws.ycypjck.com",
  //   region_id:322,
  //   map_key:'0d8f305a29a1d5072d439e9e19b2a8cc'
  // };
  //  let base_info={
  //   url:"wss://ws.tongdasheng.com",
  //   region_id:343,
  //   map_key:'a3aeef370630b6e67b61b046545b87e7'
  // };

  //   let base_info={
  //   url:"ws://puyang.ws.youzhan.info",
  //   region_id:166,
  //   map_key:'bce0f2241d66f425e1136435d2c0fed4'
  // };

  // let base_info={
  //   url:"wss://ws.gxwangong.com",
  //   region_id:97,
  //   map_key:'25dca09d8e23093ae2c3608c6738f59b'
  // };
  // let base_info={
  //   url:"wss://ws.zhenyoucaiyuncang.com",
  //   region_id:52,
  //   map_key:'e4cc3120398bdf297577c616152905d3'
  // };
  // let base_info={
  //   url:"wss://ws.changtifucai.cn",
  //   region_id:367,
  //   map_key:'ed3d56e90a016fb15cb2ad8615678aa3'
  // };
  // let base_info={
  //   url:"ws://zjkjdjc.ws.youzhan.info",
  //   region_id:148,
  //   map_key:'f3370f9b84247410b47c7900d29f3a56'
  // };
  // let base_info={
  //   url:"wss://ws.zhenmeifucai.com",
  //   region_id:143,
  //   map_key:'b4d094134761b86de230f314fc2e8772'
  // };

  // let base_info={
  //   url:"ws://ws.zhuodongyuncang.com",
  //   region_id:159,
  //   map_key:'2f98291fe33e3b53c31d75c3fea14eea'
  // };
  return base_info;
}
